// extracted by mini-css-extract-plugin
export default {"root":"DroppableCell_root__n30U1","isActive":"DroppableCell_isActive__pPkbQ"};